import React from 'react';

import CSSModule from 'react-css-modules';
import styles from './PrivacyPolicy.module.scss';

const PRIVACY_POLICY_URL = process.env.REACT_APP_PRIVACY_POLICY_URL;

const PrivacyPolicy = () => (
  <div styleName="page">
    <iframe title="Privacy Policy" src={PRIVACY_POLICY_URL} styleName="frame" />
  </div>
);

export default CSSModule(PrivacyPolicy, styles, { allowMultiple: true });
